import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { RSDescriptionList } from '../../../../../../reservation-page/description-list/RSDescriptionList';
import { RSDescriptionListItem } from '../../../../../../reservation-page/description-list/RSDescriptionListItem';

export interface CautionListForConfirmationProps {
  changeableUntil: number | null;
  cancelableUntil: number | null;
  isZoomEnabled: boolean;
  isRemoteRockEnabled: boolean;
  isPrepaymentEnabled: boolean;
}

export const CautionListForConfirmation: FC<
  CautionListForConfirmationProps
> = ({
  changeableUntil,
  cancelableUntil,
  isZoomEnabled,
  isRemoteRockEnabled,
  isPrepaymentEnabled,
}) => {
  const intl = useIntl();

  return (
    <RSDescriptionList>
      <RSDescriptionListItem
        term={intl.formatMessage({
          defaultMessage: '日程変更',
          id: '7YCXNA',
          description:
            'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
        })}
        description={(() => {
          if (changeableUntil === null) {
            return (
              <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
                {intl.formatMessage({
                  defaultMessage: '日程変更を受け付けておりません。',
                  id: '3zBNRR',
                  description:
                    'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
                })}
              </div>
            );
          }

          if (changeableUntil === 0) {
            return (
              <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
                {intl.formatMessage({
                  defaultMessage: '予約日時まで',
                  id: 'sJMZCE',
                  description:
                    'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
                })}
              </div>
            );
          }

          // 単位が日の場合
          if (changeableUntil >= 86400) {
            return (
              <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
                {intl.formatMessage(
                  {
                    defaultMessage: '予約日時の{relativeDays}日前まで',
                    id: 'o3i9gI',
                    description:
                      'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
                  },
                  {
                    relativeDays: changeableUntil / 86400,
                  },
                )}
              </div>
            );
          }

          return (
            <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
              {intl.formatMessage(
                {
                  defaultMessage: '予約日時の{relativeHours}時間前まで',
                  id: 'dyY5+0',
                  description:
                    'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
                },
                {
                  relativeHours: changeableUntil / 3600,
                },
              )}
            </div>
          );
        })()}
      />

      <RSDescriptionListItem
        term={intl.formatMessage({
          defaultMessage: 'キャンセル',
          id: 'zDxlSI',
          description:
            'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
        })}
        description={(() => {
          if (cancelableUntil === null) {
            return (
              <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
                {intl.formatMessage({
                  defaultMessage: 'キャンセルを受け付けておりません。',
                  id: 'hw5W3m',
                  description:
                    'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
                })}
              </div>
            );
          }

          if (cancelableUntil === 0) {
            return (
              <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
                {intl.formatMessage({
                  defaultMessage: '予約日時まで',
                  id: 'sJMZCE',
                  description:
                    'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
                })}
              </div>
            );
          }

          // 単位が日の場合
          if (cancelableUntil >= 86400) {
            return (
              <div>
                <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
                  {intl.formatMessage(
                    {
                      defaultMessage: '予約日時の{relativeDays}日前まで',
                      id: 'o3i9gI',
                      description:
                        'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
                    },
                    {
                      relativeDays: cancelableUntil / 86400,
                    },
                  )}
                </div>
                {isPrepaymentEnabled && (
                  <div className="rs-font text-13 text-gray-1000 pc:text-12 font-normal">
                    {intl.formatMessage({
                      defaultMessage:
                        '※ただし、事前決済の場合、キャンセル期限を過ぎていなくても、予約から 25 日が過ぎるとキャンセルできません',
                      id: 'LjUBfp',
                      description:
                        'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
                    })}
                  </div>
                )}
              </div>
            );
          }

          return (
            <div>
              <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
                {intl.formatMessage(
                  {
                    defaultMessage: '予約日時の{relativeHours}時間前まで',
                    id: 'dyY5+0',
                    description:
                      'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
                  },
                  {
                    relativeHours: cancelableUntil / 3600,
                  },
                )}
              </div>
              {isPrepaymentEnabled && (
                <div className="rs-font text-13 text-gray-1000 pc:text-12 font-normal">
                  {intl.formatMessage({
                    defaultMessage:
                      '※ただし、事前決済の場合、キャンセル期限を過ぎていなくても、予約から 25 日が過ぎるとキャンセルできません',
                    id: 'LjUBfp',
                    description:
                      'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
                  })}
                </div>
              )}
            </div>
          );
        })()}
      />

      {isZoomEnabled && (
        <RSDescriptionListItem
          term={intl.formatMessage({
            defaultMessage: 'オンラインミーティングの設定あり',
            id: 'RNgWZL',
            description:
              'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
          })}
          description={
            <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
              {intl.formatMessage({
                defaultMessage:
                  'この予約はオンラインミーティングが設定されています。接続情報は予約確認画面、予約通知メールで確認できます。',
                id: '2OuMb+',
                description:
                  'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
              })}
            </div>
          }
        />
      )}

      {isRemoteRockEnabled && (
        <RSDescriptionListItem
          term={intl.formatMessage({
            defaultMessage: 'リモートロックの設定有り',
            id: 'HG2Urk',
            description:
              'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
          })}
          description={
            <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
              {intl.formatMessage({
                defaultMessage:
                  'この予約は来店時の解除キー発行の設定がされています。解除キーの情報は予約確認画面、予約通知メールで確認できます。',
                id: 'MWgcjO',
                description:
                  'src/templates/merchants/resources/book/components/CautionListForConfirmation/index.tsx',
              })}
            </div>
          }
        />
      )}
    </RSDescriptionList>
  );
};
